import { instance } from '@/services/avik-api-gateway'
import { Event } from '@/types/event'
import { AxiosResponse } from 'axios'

export function updateEvent(
  body: Partial<Event>
): Promise<AxiosResponse<Event>> {
  return instance.put(`/event/${body.uuid}`, body)
}
